'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propEnhancers = exports.propValidators = exports.propAliases = exports.propTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getCss = require('../get-css');

var _getCss2 = _interopRequireDefault(_getCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
  boxShadow: _propTypes2.default.string
};

var propAliases = exports.propAliases = {};

var propValidators = exports.propValidators = {};

var _boxShadow = {
  className: 'bs',
  cssName: 'box-shadow',
  jsName: 'boxShadow',
  complexValue: true
};

var propEnhancers = exports.propEnhancers = {
  boxShadow: function boxShadow(value) {
    return (0, _getCss2.default)(_boxShadow, value);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbmhhbmNlcnMvYm94LXNoYWRvdy5qcyJdLCJuYW1lcyI6WyJwcm9wVHlwZXMiLCJib3hTaGFkb3ciLCJQcm9wVHlwZXMiLCJzdHJpbmciLCJwcm9wQWxpYXNlcyIsInByb3BWYWxpZGF0b3JzIiwiY2xhc3NOYW1lIiwiY3NzTmFtZSIsImpzTmFtZSIsImNvbXBsZXhWYWx1ZSIsInByb3BFbmhhbmNlcnMiLCJ2YWx1ZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7OztBQUVPLElBQU1BLGdDQUFZO0FBQ3ZCQyxhQUFXQyxvQkFBVUM7QUFERSxDQUFsQjs7QUFJQSxJQUFNQyxvQ0FBYyxFQUFwQjs7QUFFQSxJQUFNQywwQ0FBaUIsRUFBdkI7O0FBRVAsSUFBTUosYUFBWTtBQUNoQkssYUFBVyxJQURLO0FBRWhCQyxXQUFTLFlBRk87QUFHaEJDLFVBQVEsV0FIUTtBQUloQkMsZ0JBQWM7QUFKRSxDQUFsQjs7QUFPTyxJQUFNQyx3Q0FBZ0I7QUFDM0JULGFBQVc7QUFBQSxXQUFTLHNCQUFPQSxVQUFQLEVBQWtCVSxLQUFsQixDQUFUO0FBQUE7QUFEZ0IsQ0FBdEIiLCJmaWxlIjoiYm94LXNoYWRvdy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcydcbmltcG9ydCBnZXRDc3MgZnJvbSAnLi4vZ2V0LWNzcydcblxuZXhwb3J0IGNvbnN0IHByb3BUeXBlcyA9IHtcbiAgYm94U2hhZG93OiBQcm9wVHlwZXMuc3RyaW5nXG59XG5cbmV4cG9ydCBjb25zdCBwcm9wQWxpYXNlcyA9IHt9XG5cbmV4cG9ydCBjb25zdCBwcm9wVmFsaWRhdG9ycyA9IHt9XG5cbmNvbnN0IGJveFNoYWRvdyA9IHtcbiAgY2xhc3NOYW1lOiAnYnMnLFxuICBjc3NOYW1lOiAnYm94LXNoYWRvdycsXG4gIGpzTmFtZTogJ2JveFNoYWRvdycsXG4gIGNvbXBsZXhWYWx1ZTogdHJ1ZVxufVxuXG5leHBvcnQgY29uc3QgcHJvcEVuaGFuY2VycyA9IHtcbiAgYm94U2hhZG93OiB2YWx1ZSA9PiBnZXRDc3MoYm94U2hhZG93LCB2YWx1ZSlcbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/ui-box/lib/enhancers/box-shadow.js
// module id = 333
// module chunks = 0